import { GraduationCap, BookOpen, MessageSquare, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

import type { TrainingProgress } from '@/hooks/use-training-progress';

import { Card, CardContent } from '@/components/ui/card';


interface FeatureCardsProps {
  progress: TrainingProgress | undefined;
}

export function FeatureCards({ progress }: FeatureCardsProps) {
  const completed = progress?.completed_modules ?? 0;
  const total = progress?.total_modules ?? 6;

  const cards = [
    {
      to: '/training',
      icon: GraduationCap,
      title: 'Training Modules',
      subtitle: `${completed}/${total} completed`,
    },
    {
      to: '/guides',
      icon: BookOpen,
      title: 'Accommodation Guides',
      subtitle: 'Practical conversation templates',
    },
    {
      to: '/check-ins',
      icon: MessageSquare,
      title: 'Check-in Questions',
      subtitle: 'Conversation starters for 1:1s',
    },
  ];

  return (
    <div className="grid gap-4 sm:grid-cols-3">
      {cards.map(({ to, icon: Icon, title, subtitle }) => (
        <Link key={to} to={to}>
          <Card className="transition-colors hover:border-primary/50">
            <CardContent className="flex items-center gap-4 p-4">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-primary/10">
                <Icon className="h-6 w-6 text-primary" />
              </div>
              <div className="flex-1">
                <p className="font-medium">{title}</p>
                <p className="text-sm text-muted-foreground">{subtitle}</p>
              </div>
              <ChevronRight className="h-5 w-5 text-muted-foreground" />
            </CardContent>
          </Card>
        </Link>
      ))}
    </div>
  );
}
